import { Logo } from '@assets/';

export function Banner() {
  return (
    <div className="flex flex-col items-center justify-center h-10 p-[14px] border-b border-b-[#D8DCDE]">
      <img src={Logo} alt="Logo" className="w-[177px] h-[24px]" />
    </div>
  );
}
